import { NgModule, ModuleWithProviders } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';

import { HomeComponent } from './components/home/home.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { UtilityService } from './services/utility.service';
import { LoaderService } from './services/loader.service';
import { AuthGuard } from './providers/auth-guard.component';
import { AuthenticationService } from './services/authentication.service';
import { TokenInterceptor } from './services/http-interceptor.service';
import { DialogBoxComponent } from './components/dialog-box/dialog-box.component';
import { ModalComponent } from './components/modal/modal.component';
import { ErrorHandlerService } from './services/error-handler.service';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { ExtractPipe } from './pipes/extract.pipe';
import { JoinPipe } from './pipes/join.pipe';
import { EditableComponent } from './components/editable/editable.component';
import {MetaDataService} from './services/metadata.service';
import {NgbdSortableHeader} from './directives/sortable.directive';
import {EntitiesService} from './services/entitiesService.service';
import {ExcelService} from './services/excel.service';
import {AuthorizationGuard} from './providers/authorization-guard.component';
import {AuthorizationService} from './providers/authorization.service';
import {IsAuthorizedDirective} from './directives/is-authorized.directive';
import {TradxFileDirective} from './directives/tradx-file.directive';
import {
  ListNestedObjectComponent
} from './components/list-nested-object/list-nested-object.component';

import {ViewCommentsComponent} from './components/view-comments/view-comments.component';
import {ImportFromExcelComponent} from './components/import-from-excel/import-from-excel.component';
import {UploadFileComponent} from './components/upload-file/upload-file.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {KeysPipe} from './pipes/keys.pipe';
import {AddActivityLogComponent} from './components/add-activity-log/add-activity-log.component';
import {ListActivityLogComponent} from './components/list-activity-log/list-activity-log.component';
import {FilterPipe} from './pipes/filter.pipe';
import {RolesComponent} from './components/roles/roles.component';

const sharedDeclarations = [
  HomeComponent,
  PageNotFoundComponent,
  DialogBoxComponent,
  ModalComponent,
  EditableComponent,
  ListNestedObjectComponent,
  ViewCommentsComponent,
  ImportFromExcelComponent,
  UploadFileComponent,

  ClickStopPropagationDirective,
  NgbdSortableHeader,
  IsAuthorizedDirective,
  TradxFileDirective,
  AddActivityLogComponent,
  ListActivityLogComponent,
  RolesComponent,

  ExtractPipe,
  JoinPipe,
  KeysPipe,
  FilterPipe,
];

const providers = [
  AuthGuard,
  AuthenticationService,
  UtilityService,
  LoaderService,
  ErrorHandlerService,
  MetaDataService,
  EntitiesService,
  ExcelService,
  AuthorizationGuard,
  AuthorizationService,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    NgbModule,
    NgSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  declarations: sharedDeclarations,
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
  }],
  entryComponents: [
    ViewCommentsComponent,
    AddActivityLogComponent,
  ],
  exports: sharedDeclarations
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: providers
    };
  }
}
